import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
    deptId: "",
    userId: ""
	},
	mutations: {
		initDeptId(state, deptId) {
			state.deptId = deptId
		},
    initUserId(state, userId) {
      state.userId = userId
    }
	},
	actions: {

	},
	getters: {

	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js